// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__KGPuK","col":"styles_col__nEzb6"};